import { render, staticRenderFns } from "./mark-content.vue?vue&type=template&id=3fe6d3ca&scoped=true"
import script from "./mark-content.vue?vue&type=script&lang=js"
export * from "./mark-content.vue?vue&type=script&lang=js"
import style0 from "./mark-content.vue?vue&type=style&index=0&id=3fe6d3ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe6d3ca",
  null
  
)

export default component.exports